import React, { useContext, useState } from 'react';
import IndicaMaisImg from '../../assets/novosicones/IndicaMais/Promocao-indica-mais.png';
import { ButtonPrimary } from '../StyledComponent';
import { ContainerIndicaMais } from './styles';
import ModalIndicacao from './ModalIndicacao';
import MessagePopUp from '../MessagePopup';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';

function IndicaMais() {
  const [showModalIndicacao, setShowModalIndicacao] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [isShowSuccessModal, setIsShowSuccessModal] = useState(false);
  const { tema } = useContext(ContextoListaApartamentos);
  const URL_REGULAMENT =
    'https://podemorar-termos.s3.amazonaws.com/REGULAMENTO_DE_PROMO%C3%87%C3%83O_-_Indica_Mais_Vers%C3%A3o_final_1307.pdf';

  function redirectToRegulation() {
    window.open(URL_REGULAMENT);
  }

  function toggleShowModalIndicacao() {
    setShowModalIndicacao(!showModalIndicacao);
  }

  function toggleErrorModal() {
    setIsShowErrorModal(!isShowErrorModal);
  }

  function toggleSuccessModal() {
    setIsShowSuccessModal(!isShowSuccessModal);
  }

  return (
    <ContainerIndicaMais tema={tema}>
      <img
        src={IndicaMaisImg}
        alt='imagem indica mais'
        className='img-indica-mais'
      />
      <div className='container-infos-indica-mais'>
        <h3 className='title-indica-mais'>Promoção Indica Mais</h3>
        <span className='subtitle-indica-mais'>
          Mais vantagem para você e mais pessoas realizando sonhos
        </span>

        <div className='container-buttons-indica-mais'>
          <ButtonPrimary
            tema={tema}
            fullWidth
            ghost
            onClick={redirectToRegulation}
          >
            VER REGULAMENTO
          </ButtonPrimary>

          <ButtonPrimary
            tema={tema}
            white
            fullWidth
            onClick={toggleShowModalIndicacao}
          >
            FAZER INDICAÇÃO
          </ButtonPrimary>
        </div>
      </div>
      {showModalIndicacao && (
        <ModalIndicacao
          tema={tema}
          showSuccessModal={toggleSuccessModal}
          showErrorModal={toggleErrorModal}
          closeModal={toggleShowModalIndicacao}
          urlRegulament={URL_REGULAMENT}
        />
      )}

      {isShowSuccessModal && (
        <MessagePopUp
          tema={tema}
          title={'Indicação realizada com sucesso'}
          message={`Obrigada pela indicação. Em breve, entraremos em contato 
            para realizar o sonho da casa própria da pessoa você que indicou.`}
        >
          <ButtonPrimary tema={tema} fullWidth onClick={toggleSuccessModal}>
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {isShowErrorModal && (
        <MessagePopUp
          tema={tema}
          isError
          title={'Indicação temporariamente indisponível'}
          message={`Não foi possível concluir a sua indicação, volte mais tarde
             e tente novamente.`}
        >
          <ButtonPrimary tema={tema} fullWidth onClick={toggleErrorModal}>
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </ContainerIndicaMais>
  );
}

export default IndicaMais;
